import '@/css/app.pcss';
import { app } from '@/js/main';

window.addEventListener('DOMContentLoaded', app);

// See https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept('@/js/main', newApp => {
    newApp?.app();
  });
}
